import { Injectable } from '@angular/core';
import { emulator } from './emulator.service';
import { MatDialog } from '@angular/material/dialog';
import { OutboundSsoConfirmationDialogComponent, OutboundSsoConfirmationData } from '../components/dialogs/outboundSso-confirmation.component';
import { TranslationPipe } from '../pipes/translation.pipe';

@Injectable({
  providedIn: 'root',
})
export class OutboundSsoService {
  constructor(private enumalatorService: emulator, private dialog: MatDialog,private translationPipe: TranslationPipe) {}
  /**
   * Opens url in _blank tab. Url is determined by ssoType parameter.
   * @param ssoType
   */
  openSsoUrl(ssoType: string, ssoEndPoint: string) {
    if (this.enumalatorService.showAuditorInfo()) {
      return;
    } else {  
      window.open(ssoEndPoint, '_blank');
    }
  }

  showConfirmationDialog(ssoType:string,ssoLink:string):void{
          this.dialog.open(OutboundSsoConfirmationDialogComponent,{
            data: { message : this.translationPipe.transform('You are opening a new tab or window to an external site. Please disable popup blockers if needed.'),
              ssoType, ssoEndPoint : ssoLink
            } as OutboundSsoConfirmationData
     });
  }
}
